import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppSearchSiteViewComponent } from './app-search-site-view/app-search-site-view.component';
import { DeleteMeComponent } from './delete-me/delete-me.component';



const routes: Routes = [
  {
    path: '',
    component: AppSearchSiteViewComponent,
    children: [
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppSearchSiteRoutingModule { }
